// 비회원 접근 가능한 URL 정의
export default {
    'allow-nomember': [
        "/",
        "/Event",
        "/EventNews/MonthSample", 
        "/ServiceUse",
        "/Renewal",
        "/DailyMarket",
        "/TodayWorld", 
        "/stockitem",
        "/Ticker",
        "/Theme/ThemeDB/ThemeDBAllowed",
        "/Theme/ThemeDB/ThemeAllAllowed", 
        "/Company/Analysis/EtfRelation", 
        "/Company/Analysis/StockHistory", 
        "/Company/Analysis/StockThemeChart",
        "/Company/Analysis/StockInfo",
        "/Login",
        "/SignUp",
        "/Policy",
        "/Principle",
        "/PolicyYouth",
        "/Care",
        "/IR_groups",
        "/CustomerCenter/Notice",
        "/CustomerCenter/Ad",
        "/MobileStockPaper",
        "/MarketNewsFlash",
        "/issuccess",
        "/Company/TechnicalAnalysis",
        "/Company/Disclosure",
        "/Company/ShortSellingRanking",
        "/Company/LoanTransaction",
        "/Company/DailyShareChange",
        "/Company/DailyTreasuryStock",
        "/Company/RiseDropRateRanking",
        "/Company/ForeignInstBuySellRanking",
        "/Company/ForeignInstContinueRanking",
        "/Company/ForeignBuySellRanking",
        "/Company/VolumeJump",
        "/Company/QuoteUnusual",
        "/Company/CreditRatioRanking",
        "/Company/TodayPopularSearch",
        "/Company/VI",
        "/Company/100MBuySellRanking",
        "/Company/MarketAction",
        "/Company/MiddleFeatures",
        "/Company/Analysis/Earning",
        "/Theme/DailyFeaturedTheme",
        "/MarketNews/TodaySummary",
        "/MarketNews/DailyNewsBriefing",
        "/MarketNews/KOSPI",
        "/MarketNews/KOSDAQ",
        "/MarketNews/Futures",
        "/MarketNews/ForeignExchange",
        "/MarketNews/Bond",
        "/MarketNews/China",
        "/MarketNews/Japan",
        "/MarketNews/Taiwan",
        "/MarketNews/Semicon",
        "/MarketNews/NewYorkClosing",
        "/MarketNews/NewYorkExchange",
        "/MarketNews/NewYorkBond",
        "/MarketNews/CrudeOilPrice",
        "/MarketNews/SOX",
        "/Research/MainEarning",
        "/IR_B2B/IRCompanies",
        "/Company/StockTreasury",
        "/Theme/ThemeFluctuations",
        "/MarketNews/MajorCompaniesFluctuationRate",
        "/MarketNews/ExchangeRate_ProductsTrend",
        "/MarketNews/MajorCountriesIndex",
        "/IR_B2B/IR",
        "/IR_B2B/FinancialNews",
        "/IR_B2B/FlashService",
        "/IR_B2B/MarketService",
        "/IR_B2B/ThemeService",
        "/IR_B2B/HistoryService",
        "/IR_B2B/DataService",
        "/IR_B2B/ScheduleService",
        "/Verification",
        // "/Company/Analysis/StockInfo/Preview",
        // "/Theme/ThemeDB/Preview",
        // "/Theme/ThemeDB/ThemeAllPreview",
        // "/Theme/Us/ThemeDB/Preview",
        // "/Theme/Us/ThemeDB/ThemeAllPreview",
        // "/MarketNews/DailyNewsBriefing/Preview",
        // "/Company/TodayIssues/Preview",
        // "/Theme/Etf/EtfTheme/Preview",
        // "/Theme/Etf/EtfTheme/ThemeAllPreview",
        // "/EventNews/MonthPreview",
    ],
}
